Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Members410053897",
  {"root":"Members410053897--root","memberItem":"Members410053897--memberItem","userInfo":"Members410053897--userInfo","nickAndRole":"Members410053897--nickAndRole","roleBadge":"Members410053897--roleBadge","username":"Members410053897--username","mainButtons":"Members410053897--mainButtons","moreActions":"Members410053897--moreActions"},
  "",
  12,
  "Members410053897"
);

